import { HorizBox, Narrow } from "component/basics";
import { DemoHeader, DemoSection } from "system/demo"
import { MaskedView } from "platform-specific/zdf/maskedView";
import { makeAssetUrl } from "util/util";
import { UtilityText } from "component/text";
import { View } from "react-native";
import { colorTeaserBackground } from "component/color";


export function MaskedViewDemo() {
    return <Narrow>
        <DemoSection text={ "Masked component"}>
            <UtilityText text="Note: Due to CORS restriction of the mask image url, this demo might not work on the development server."/>
            <MaskedView imageUrl={makeAssetUrl('/images/bubbles.png')} style={{width: 100, height: 100}}>
            <View style={{backgroundColor: colorTeaserBackground}}>
                <UtilityText text="Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut"></UtilityText>  
            </View>
            </MaskedView>
        </DemoSection>
    </Narrow>
}